import type { ThemeOptions } from '@mui/material';

export const shape: ThemeOptions['shape'] = {
  borderRadius: 10,
};
